import jwt_decode from 'jwt-decode';

const jwtToken = 'jwtToken';
const tokenExpiredMsgErrorText = 'Token expired';

class APIHelper {
  static async checkStatus(response: Response) {
    if (response.status >= 200 && response.status < 300) {
      return response;
    }
    if (response.status === 401) {
      const data = await response.json();
      if (data.code === 'token_not_valid') {
        throw new Error(tokenExpiredMsgErrorText);
      } else {
        throw new Error(response.statusText);
      }
    }
    if (response.status === 403) {
      throw new Error(
        "You don't have the access rights to modify the resource",
      );
    }
    if (response.status === 404) {
      throw response;
    }
    throw new Error(response.statusText);
  }

  static parseJSON<T>(response: Response) {
    return response.json() as Promise<T>;
  }

  static parseText(response: Response) {
    return response.text();
  }

  static getJwtToken = () =>
    JSON.parse(localStorage.getItem(jwtToken) as string);

  static setJwtToken = (jwtTokenContent: Record<string, string>) =>
    localStorage.setItem(jwtToken, JSON.stringify(jwtTokenContent));

  static getAccessToken = () => this.getJwtToken()?.access;

  static getRefreshToken = () => this.getJwtToken()?.refresh;

  static removeJwtToken = () => localStorage.removeItem(jwtToken);

  static decodeToken = (accessToken: string) =>
    jwt_decode<{
      exp: number;
      username: string;

      permissions?: { can_change_bulletin: boolean };
    }>(accessToken);

  static isTokenExpired = (accessToken: string) => {
    if (!accessToken) {
      return null;
    }
    const decodedToken = APIHelper.decodeToken(accessToken);
    if (!decodedToken?.exp) {
      return null;
    }
    return Date.now() >= decodedToken?.exp * 1000;
  };

  static errorIsTokenExpired = (message: string) =>
    message === tokenExpiredMsgErrorText ||
    message === `Error: ${tokenExpiredMsgErrorText}`;

  static getUserInfoFromToken = (accessToken: string) => {
    const decodedToken = APIHelper.decodeToken(accessToken);
    return {
      username: decodedToken?.username,
      hasBulletinPermission: decodedToken?.permissions?.can_change_bulletin,
    };
  };
}

export default APIHelper;
